import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  /* Container */
  root: {
    height: 104,
    boxSizing: 'border-box',
    padding: 24,
    display: 'flex',
    flexWrap: 'nowrap',            // wrap only at ≤1024px
    justifyContent: 'flex-start',
    gap: 13,
  },

  /* Each card */
  card: {
    height: 56,
    minWidth: 300,                 // base (≥1921px)
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12,
  },

  /* Icon box */
  iconBox: {
    height: 56,
    width: 56,
    backgroundColor: 'rgba(250, 250, 250, 1)',
    border: '1px solid rgba(238, 238, 238, 1)',
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  iconImg: { height: 32, width: 32 },

  /* Text column */
  textCol: {
    height: '50px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    minWidth: 0,   // critical for ellipsis inside flex
    flex: 1,
  },

  /* Base typography (≥1921px) */
  label: {
    fontSize: '14px',
    color: 'rgba(95, 96, 113, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    lineHeight: 'normal',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    minWidth: 200,
  },
  value: {
    fontSize: '14px',
    lineHeight: '32px',
    color: 'rgba(69, 70, 83, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    lineHeight: 'normal',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    minWidth: 200,
  },

  /* ====== ≤1920px (new: step fonts down slightly) ====== */
  '@media (max-width:1920px)': {
    label: { fontSize: 13 },
    value: { fontSize: 15, lineHeight: '30px' },
  },

  /* ====== ≤1440px (still NO wrap) ====== */
  '@media (max-width:1440px)': {
    root: {
      padding: 22,
      gap: 12,
      // keep no wrap here
    },
    card: { minWidth: 285 },
    iconBox: { height: 54, width: 54 },
    iconImg: { height: 30, width: 30 },
    textCol: { height: 36 },
    label: { fontSize: 12, minWidth: 190 },
    value: { fontSize: 14, lineHeight: '28px', minWidth: 190 },
  },

  /* ====== ≤1280px (still NO wrap) ====== */
  '@media (max-width:1280px)': {
    root: {
      padding: 20,
      gap: 12,
    },
    card: { minWidth: 270 },
    label: { fontSize: 11, minWidth: 180 },
    value: { fontSize: 13, lineHeight: '26px', minWidth: 180 },
  },

  /* ====== ≤1024px (WRAP ON) ====== */
  '@media (max-width:1024px)': {
    root: {
      padding: 16,
      gap: 10,
      height: 'auto',          // allow multiple rows
      flexWrap: 'wrap',        // enable wrap only here
    },
    card: {
      minWidth: 240,
      height: 54,
      gap: 10,
      // Uncomment if you want a tidy 2-column grid when wrapping:
      // flex: '0 1 calc(50% - 10px)',
    },
    iconBox: { height: 50, width: 50 },
    iconImg: { height: 28, width: 28 },
    textCol: { height: 34 },
    label: { fontSize: 11, minWidth: 160 },
    value: { fontSize: 12, lineHeight: '22px', minWidth: 160 },
  },
}));

export default useStyles;
